import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "@smartling-ui/link";
import { Text } from "@smartling-ui/typography";

import messages from "./messages";
import * as styles from "./styles.module.css";

const linkLogin = (
    <Link href="/" size="inherit" weight="inherit">
        <FormattedMessage {...messages.loginLink} />
    </Link>
);

export function SignInLink() {
    return (
        <Text size="sm" className={styles.signIn}>
            <FormattedMessage
                {...messages.alreadyHaveAccount}
                values={{ link: linkLogin }}
            />
        </Text>
    );
}
